import React from 'react'

import { sanitizeAndProcessHtml } from '@/_lib/dom-purify.utils'

export interface ParagraphData {
	text: string
}

export interface BEditorJsParagraphProps {
	data: ParagraphData
}

export const BEditorJsParagraph: React.FC<BEditorJsParagraphProps> = ({ data }) => {
	const { text } = data

	return (
		<div className='editorjs-renderer_block'>
			<p
				className='editorjs-renderer_paragraph'
				suppressHydrationWarning
				dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(text) }}
			/>
		</div>
	)
}

export default BEditorJsParagraph
